// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.social-share';

/**
 * automatické ošetření sdílecích tlačítek.
 *
 * HTML markup
 * <div class="js_social-share">
 *     <a href="javascript:void(0)" data-social-network="twitter"> Sdílet na Twitteru</a>
 * </div>
 *
 * data-social-network: facebook | twitter | gplus | linkedin | pinterest
 *
 * na odkaz možno dodat data:
 * data-share-title - vlastní titulek (pokud má být různý od document.title)
 * data-url-share - vlastní URL sdíleného článku, pokud se má lišit od document.URL
 * data-pinterest-image - podstrčení obrázku, který má být připinnován na pinterest
 */
export default class SocialShare extends WebComponent {
  didMount() {
    $(this.element).socialShare();
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/SocialShare.js